import styles from './FilterLayout.module.scss'
import { SelectOption } from '@types';
import Search from 'src/components/search/course-search/CourseSearch';
import Button from 'src/components/button/Button';
import Select from 'src/components/select/Select';
import IconRotating from 'src/assets/icons/rotating_arrow.svg?react';

type Props = {
    country: string
    keyword: string
    handleChangeSearch: (value: string) => void
    handleChangeCountry: (option: SelectOption) => void
    handleResetFilters: () => void
}

const countriesOptions = [
    { label: 'Australia', value: 'Australia' },
    { label: 'Canada', value: 'Canada' },
    { label: 'USA', value: 'USA' },
  ]

function FilterLayout(props: Props) {
  const { country, keyword, handleResetFilters, handleChangeSearch, handleChangeCountry } = props

  return (
    <div className={styles.filters}>
      <Search onChange={handleChangeSearch} value={keyword} />
      <Select showSearch={false} inline={false} value={country} onChange={handleChangeCountry} placeholder={'Country'}
        label={'Country'}
        options={countriesOptions} />
      <Button onClick={handleResetFilters} className={styles.resetBtn} label={'Reset'}
          size={'extraSmall'} outline={true} color={'green'}
          leftIcon={<IconRotating className={styles.resetIcon} />} />
    </div>
  )
}

export default FilterLayout